import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-clock-outline",
  "use": "icon-clock-outline-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-clock-outline\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h28v28H0z\" /><path d=\"M14 25.667C7.556 25.667 2.333 20.443 2.333 14 2.333 7.556 7.556 2.333 14 2.333S25.667 7.556 25.667 14 20.443 25.667 14 25.667Zm0-2.334a9.333 9.333 0 1 0 0-18.666 9.333 9.333 0 0 0 0 18.666ZM15.167 14h4.666v2.333h-7V8.167h2.334V14Z\" fill=\"#B3B3B3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol